export default __webpack_public_path__ + "static/media/004-big ben.27ca4e60.svg";